export { default as DressingRuleListTemplate } from "./DressingRuleListTemplate";
export { default as DressingRuleEditTemplate } from "./DressingRuleEditTemplate";
